import { SET_PAYMENT_ERROR, SET_PAYMENT_STAGE, SET_PAYMENT_URL,SET_PAYMENTS_DETAILS } from "../const";


export function setIsPaymentError(isError: boolean) {
    return {
        type: SET_PAYMENT_ERROR,
        payload: isError
    };
}

export function setPaymentURL(paymentURL: string) {
    return {
        type: SET_PAYMENT_URL,
        payload: paymentURL
    };
}
export function setPaymentStage(paymentStage: number) {
    return {
        type: SET_PAYMENT_STAGE,
        payload: paymentStage
    };
}
export function setPaymentDetails(paymentDetails: {
    venueName:string;
    acquirerName?:string;
    paymentProcessor:string;
    onboardingSource:string;
  }) {
    return {
      type: SET_PAYMENTS_DETAILS,
      payload: paymentDetails,
    };
  }